<template>
    <div class="animated fadeIn" id="faturamento-desenvolvedores">
        <div class="card card-default">
            <div class="card-header">
                <div class="card-header">
                    <i class="fa fa-money"></i> Melhorias por Desenvolvedores
                </div>
            </div>
            <div class="card-body">
                <!-- Primeira linha: Ano -->
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <!-- Ano -->
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Ano
                    </span>
                    <YearPicker v-model="ano" class="input-custom" style="width: 260px; margin-right: 8px;" />
                </div>
                <!-- Segunda linha: Pesquisar -->
                <div class="d-flex justify-content-end">
                    <button class="btn btn-primary" style="height: 40px;" @click="pesquisar">
                        <i class="icon-magnifier"></i> Pesquisar
                    </button>
                </div>
                <!-- Tabela de Horas por Milestone -->
                <div v-if="registrosHorasMilestone.length > 0" class="mt-4">
                    <table class="table table-bordered table-striped table-sm text-center align-middle">
                        <thead>
                            <tr>
                                <th>Desenvolvedor</th>
                                <th v-for="milestone in milestonesUnicas" :key="milestone">{{ milestone }}</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(analista, idx) in tabelaOrcamento">
                                <tr :key="`analista-${idx}`">
                                    <td>
                                        {{ analista.nome_dev }}
                                    </td>
                                    <td v-for="milestone in milestonesUnicas" :key="`cell-${milestone}`">
                                        <span style="cursor:pointer; color:#007bff;"
                                            @click="toggleExpandMilestone(analista.nome_dev, milestone)">
                                            {{ analista.milestones[milestone] || '0.00' }}
                                        </span>
                                    </td>
                                    <td>{{ analista.total }}</td>
                                </tr>
                                <!-- Exibe as issues em uma linha única, sem divisão de colunas -->
                                <template v-for="milestone in milestonesUnicas">
                                    <template
                                        v-if="issuesPorMilestone[`${analista.nome_dev}-${milestone}`] && issuesPorMilestone[`${analista.nome_dev}-${milestone}`].length > 0">
                                        <tr :key="`issues-row-${analista.nome_dev}-${milestone}`">
                                            <td colspan="100%">
                                                <table class="table table-bordered table-sm" style="margin-bottom:0;">
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Título</th>
                                                            <th>Orçado</th>
                                                            <th>Realizado</th>
                                                            <th>Horas Devs</th>
                                                            <th>% Desenv. Gasto</th>
                                                            <th>% Participação</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(issue, iidx) in issuesPorMilestone[`${analista.nome_dev}-${milestone}`]"
                                                            :key="`issue-data-${iidx}`">
                                                            <td>{{ issue.id }}</td>
                                                            <td
                                                                style="max-width: 320px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; position: sticky; left: 0; background: #fff; z-index: 2;"
                                                                :title="issue.titulo">
                                                                {{ issue.titulo && issue.titulo.length > 60 ? issue.titulo.slice(0, 57) + '...' : issue.titulo }}
                                                            </td>
                                                            <td>{{ issue.total_orcado }}</td>
                                                            <td>{{ issue.total_realizado }}</td>
                                                            <td>{{ issue.total_horas_apontadas_devs }}</td>
                                                            <td :style="{ color: corPorcentagemDesenvolvimento(issue.porcentagem_desenvolvimento_gasto), fontWeight: '600' }">
                                                                {{ issue.porcentagem_desenvolvimento_gasto }}
                                                            </td>
                                                            <td>{{ issue.porcentagem_participacao_desenvolvimento }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import YearPicker from "@/components/YearPicker.vue"; // ajuste o path se necessário

export default {
    name: 'FaturamentoDesenvolvedoresIndex',
    components: {
        YearPicker,
    },
    data() {
        return {
            profissionais: [],
            ano: null,
            milestoneFormatado: "",
            registrosHorasMilestone: [],
            milestonesUnicas: [],
            tabelaOrcamento: [],
            analistasExpandido: [],
            issuesPorMilestone: {},
        };
    },
    watch: {
        ano(val) {
            // Atualiza milestoneFormatado sempre que o ano for selecionado
            this.anoFormatado = val ? String(val) : "";
        }
    },
    async mounted() {
        await this.getProfissionais();
        this.gerarMesesAnoVigente();
    },
    methods: {
        corPorcentagemDesenvolvimento(valor) {
            const porcentagem = parseFloat(valor);
            if (isNaN(porcentagem)) {
                return "#333";
            }
            if (porcentagem >= 100) {
                return "#dc3545";
            }
            if (porcentagem >= 80) {
                return "#d4a017";
            }
            if (porcentagem >= 35) {
                return "#28a745";
            }
            return "#0056b3";
        },
        async getProfissionais() {
            try {
                const response = await this.$http.get("/faturamento/desenvolvedores");
                this.profissionais = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Erro ao buscar profissionais:', error);
                this.profissionais = [];
            }
        },
        onChangeAno(val) {
            if (val) {
                // val é um objeto Date, pega apenas o ano
                const ano = val.getFullYear();
                this.anoFormatado = `${ano}`;
            } else {
                this.anoFormatado = "";
            }
        },
        pesquisar() {
            console.log('Ano:', this.anoFormatado);
            // Limpa todas as issues expandidas antes de pesquisar
            this.issuesPorMilestone = {};
            this.analistasExpandido = [];
            this.buscaHorasPorAno();
        },

        async buscaHorasPorAno() {
            try {
                const response = await this.$http.get("/faturamento/competencias-devs-horas-melhorias", {
                    params: {
                        ano: this.anoFormatado
                    }
                });
                this.registrosHorasMilestone = Array.isArray(response.data.registros) ? response.data.registros : [];
                // Gera as colunas de acordo com os milestones retornados
                const milestonesSet = new Set(this.registrosHorasMilestone.map(r => r.milestone));
                this.milestonesUnicas = Array.from(milestonesSet).sort((a, b) => {
                    // Ordena por ano e mês
                    const [ma, ya] = a.split('-');
                    const [mb, yb] = b.split('-');
                    if (ya !== yb) return ya - yb;
                    return ma - mb;
                });
                // Extrai nomes únicos dos desenvolvedores presentes nos registros
                const nomesDevs = [
                    ...new Set(this.registrosHorasMilestone.map(r => r.nome_dev))
                ];
                // Monta tabela apenas para os desenvolvedores presentes nos registros
                this.tabelaOrcamento = nomesDevs.map(nomeDev => {
                    const milestones = {};
                    let total = 0;
                    this.milestonesUnicas.forEach(milestone => {
                        // Busca registro para esse desenvolvedor e milestone
                        const registro = this.registrosHorasMilestone.find(r =>
                            r.nome_dev === nomeDev && r.milestone === milestone
                        );
                        let horas = registro
                            ? (registro.total_em_melhoria !== undefined && registro.total_em_melhoria !== null
                                ? registro.total_em_melhoria
                                : '0.00')
                            : '0.00';
                        if (typeof horas !== 'string') {
                            horas = String(horas !== undefined && horas !== null ? horas : '0.00');
                        }
                        milestones[milestone] = horas;
                        total += parseFloat(horas.replace(',', '.')) || 0;
                    });
                    return {
                        nome_dev: nomeDev,
                        milestones,
                        total: total.toFixed(2)
                    };
                });
            } catch (error) {
                console.error('Erro ao buscar horas por milestone:', error);
                this.registrosHorasMilestone = [];
                this.tabelaOrcamento = [];
                this.milestonesUnicas = [];
            }
        },
        gerarMesesAnoVigente() {
            const ano = new Date().getFullYear();
            this.milestonesUnicas = Array.from({ length: 12 }, (_, i) => {
                const mes = String(i + 1).padStart(2, '0');
                return `${mes}-${ano}`;
            });
        },
        async toggleExpandMilestone(analista, milestone) {
            const key = `${analista}-${milestone}`;
            const idx = this.analistasExpandido.indexOf(key);
            if (idx === -1) {
                this.analistasExpandido.push(key);
                await this.buscarIssuesPorMilestone(analista, milestone);
            } else {
                this.analistasExpandido.splice(idx, 1);
                // Retrai/remover as issues da visualização
                this.$delete(this.issuesPorMilestone, key);
            }
        },
        async buscarIssuesPorMilestone(analista, milestone) {
            try {
                const profissional = this.profissionais.find(p => p.nome === analista);
                if (!profissional || !profissional.id) {
                    this.$set(this.issuesPorMilestone, `${analista}-${milestone}`, []);
                    return;
                }
                const response = await this.$http.get(
                    "/faturamento/faturado-vs-realizado-dev",
                    {
                        params: {
                            usuario_id: profissional.id,
                            milestone
                        },
                        headers: { 'Content-Type': 'application/json' }
                    }
                );
                this.$set(this.issuesPorMilestone, `${analista}-${milestone}`, response.data.issues || []);
            } catch (error) {
                this.$set(this.issuesPorMilestone, `${analista}-${milestone}`, []);
            }
        },

    }
}
</script>

<style>
.teste {
    padding: 16px;
    background: #f0f0f0;
    border-radius: 4px;
    font-weight: bold;
}

.input-group-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 14px;
    height: 40px;
}

/* Dropdown customizado para Profissional e Sistema */
.custom-dropdown .dropdown-toggle,
.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active,
.custom-dropdown.show .dropdown-toggle,
.custom-dropdown .dropdown-toggle.btn-primary,
.custom-dropdown.show .dropdown-toggle.btn-primary {
    background-color: transparent !important;
    border: 1px solid #dde2e7 !important;
    color: #6c757d !important;
    box-shadow: none !important;
    width: 260px !important;
    min-width: 180px !important;
    max-width: 260px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    line-height: 38px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

/* Ajuste opcional: remover outline de foco do Bootstrap */
.custom-dropdown .dropdown-toggle:focus {
    outline: none !important;
}

/* Dropdown menu */
.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
    min-width: 260px !important;
    width: 260px !important;
    max-width: 260px !important;
    padding: 0;
    /* Remove fixed height here, use scroll on inner div */
}

/* Dropdown item */
.custom-dropdown .dropdown-item {
    min-width: 260px;
    width: 260px;
    max-width: 260px;
}

.datepicker-custom {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    font-size: 14px;
}

.sistema-select {
    height: 40px !important;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #dde2e7;
    background: #fff;
    color: #333;
    padding: 0 8px;
    min-width: 280px;
    width: 280px;
    max-width: 280px;
    text-align: center;
}

/* Estilo para o placeholder do select de sistemas */
.sistema-select option.sistema-placeholder {
    color: #6c757d !important;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    background: #fff;
}

.sistema-placeholder {
    color: #6c757d !important;
}

.sistema-select-modal {
    height: 40px !important;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #dde2e7;
    background: #fff;
    color: #333;
    padding: 0 8px;
}

/* --- INÍCIO: Layout replicado do dropdown de alocacao-horas --- */
.custom-dropdown .dropdown-toggle {
    background-color: transparent !important;
    border: 1px solid #6c757d !important;
    color: #6c757d !important;
    border-radius: 4px;
}

.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
    box-shadow: none !important;
}

/* Customização do botão quando está aberto */
.custom-dropdown.show .dropdown-toggle {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
}

/* Customização do menu dropdown */
.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
}

/* --- FIM: Layout replicado do dropdown de alocacao-horas --- */

/* Remover estilos antigos conflitantes do dropdown antigo */
.custom-dropdown .dropdown-toggle,
.custom-dropdown .dropdown-toggle.btn-primary,
.custom-dropdown.show .dropdown-toggle.btn-primary {
    /* removido: background-color, border, color, box-shadow, width, min-width, max-width, height, min-height, max-height, line-height, padding-top, padding-bottom */
}

.custom-dropdown .dropdown-menu {
    /* removido: min-width, width, max-width, padding */
}

/* Esconde anos fora de 2023-2025 no painel de anos do vue2-datepicker */
.mx-panel-year .cell {
    display: none;
}

.mx-panel-year .cell:nth-child(4),
.mx-panel-year .cell:nth-child(5),
.mx-panel-year .cell:nth-child(6) {
    display: inline-block;
}





.mx-panel-year .mx-btn-current-year::after {
    content: "2023 ~ 2025";
    color: #333;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    text-align: center;
    width: 100%;
    pointer-events: none;
}

/* Estilo padronizado para todos os inputs customizados */
.input-custom,
.input-custom .dropdown-toggle,
.input-custom .form-control,
.input-custom input,
.input-custom .datepicker-custom {
    background: #fff !important;
    border: 1px solid #dde2e7 !important;
    color: #333 !important;
    border-radius: 4px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px !important;
    box-shadow: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.input-custom input::placeholder,
.input-custom .form-control::placeholder {
    color: #6c757d !important;
    opacity: 1;
}

.input-custom .dropdown-toggle {
    width: 260px !important;
    min-width: 180px !important;
    max-width: 260px !important;
    line-height: 38px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
}

/* Remove highlight azul do bootstrap ao focar */
.input-custom .dropdown-toggle:focus,
.input-custom .form-control:focus,
.input-custom input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #a0a0a0 !important;
}

/* Ajuste para YearPicker se necessário */
.input-custom .mx-input,
.input-custom .mx-input:focus {
    background: #fff !important;
    border: 1px solid #dde2e7 !important;
    color: #333 !important;
    border-radius: 4px !important;
    height: 40px !important;
    font-size: 14px !important;
    box-shadow: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>